import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/email-logs")
export class AdminViewEmailLogsBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.emailLogs;
}
